<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

defineProps({
  modelValue: { type: String, default: '' },
});

const emit = defineEmits(['update:modelValue']);
const { t } = useI18n();
const options = computed(() => [
  {
    id: 'pix',
    label: t('REAL_ESTATE_COMMISSION_INSTALLMENT.PAYMENT.PIX'),
  },
  {
    id: 'banco',
    label: t('REAL_ESTATE_COMMISSION_INSTALLMENT.PAYMENT.BANK'),
  },
]);
</script>

<template>
  <fieldset class="grid grid-cols-2 gap-3">
    <button
      v-for="option in options"
      :key="option.id"
      type="button"
      class="rounded-lais border p-3 text-left text-sm font-semibold"
      :class="
        modelValue === option.id
          ? 'border-lais-primary bg-lais-primary-50 text-lais-primary'
          : 'border-lais-border bg-white text-lais-text'
      "
      @click="emit('update:modelValue', option.id)"
    >
      {{ option.label }}
    </button>
  </fieldset>
</template>
